/* src/app/shared/record-timer/record-timer.component.scss */
.rtimer {
  border: 10px solid red;
  border-top: 5px solid red;
  background: black;
  color: white;
  text-align: left;
  font-family: "digitaltimer";
  padding-left: 5px;
  padding-right: 5px;
  border-bottom: 1px solid darkslategray;
  border-radius: 3px;
}
.rtimer p {
  font-family: "digitaltimer";
  font-size: small;
  padding: 0;
  margin: 0;
  margin-top: 2px;
  margin-bottom: 5px;
}
.middlep {
  font-family: "digitaltimer";
  text-align: right;
  line-height: 1;
}
.middlep span {
  float: left;
  font-family: "digitaltimer";
  margin-right: 5px;
}
.country {
  font-family: "digitaltimer";
  float: left;
  margin-right: 10px;
}
.lowerp {
  font-family: "digitaltimer";
  text-align: left;
  line-height: 1;
  display: block;
  margin-bottom: 2px !important;
}
.type {
  background-color: white;
  color: black;
  margin-left: 5px;
  margin-bottom: 2px;
  margin-right: 10px;
  padding: 2px;
  padding-top: 3px;
  font-family: "digitaltimer";
  padding-bottom: 0px;
}
.rttime {
  font-family: "digitaltimer";
  float: right;
}
.flag {
  float: left;
  max-height: 1em;
  margin-right: 10px;
}
/*# sourceMappingURL=record-timer.component.css.map */
